import React from "react";
import PropTypes from "prop-types";

import { UserAvatar } from "../UserAvatar/UserAvatar";
import styles from "./RadioButton.module.scss";
import clsx from "clsx";
import Label from "../Label/Label";

const RadioButton = ({
  color,
  colorLabel,
  alignment,
  hideLabel,
  disabled,
  onChange,
  value,
  item,
  name,
}) => {
  const checked = value === item.value;

  const radioClasses = clsx(styles.radioButton, {
    [styles.checked]: checked,
    [styles.primary]: checked || color === "primary",
    [styles.error]: checked && color === "error",
  });

  const input = (
    <div className={radioClasses} data-testid="RadioButtonInput">
      <input
        className="d-none"
        type="radio"
        checked={checked}
        data-testid="RadioButtonInputReal"
        disabled={!!disabled}
        name={name}
        readOnly={true}
      />
    </div>
  );

  const labelClasses = clsx(styles.pointer, "mb-0", "font-weight-normal", {
    "ml-3": alignment === "left",
  });

  const isRight = alignment === "right";

  const radioContainerClasses = clsx("d-flex align-items-center", {
    "justify-content-between": isRight,
    "mb-2": !isRight,
  });

  return (
    <div
      className={radioContainerClasses}
      data-testid="RadioButton"
      onClick={() => {
        if (!disabled) {
          onChange(item.value);
        }
      }}
    >
      {alignment === "left" && input}
      {!hideLabel ? (
        <Label color={colorLabel} className={labelClasses} htmlFor={name}>
          {item.image || item.includeAvatar ? (
            <UserAvatar name={item.label} label={item.label} image={item.image} />
          ) : (
            item.label
          )}
        </Label>
      ) : null}
      {alignment === "right" && input}
    </div>
  );
};

RadioButton.propTypes = {
  color: PropTypes.oneOf(["primary", "error"]),
  colorLabel: PropTypes.string,
  alignment: PropTypes.string,
  hideLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  item: PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string,
    image: PropTypes.string,
    includeAvatar: PropTypes.bool,
  }),
  name: PropTypes.string,
};

RadioButton.defaultProps = {
  color: "primary",
  alignment: "right",
  hideLabel: false,
  disabled: false,
  item: {},
};

export default RadioButton;
